/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Render_Tts_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Render text-to-speech audio" |
*
* @param {Event_Ad_Render_Tts_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_render_tts_aria_label = /** @type {((inputs?: Event_Ad_Render_Tts_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Render_Tts_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Generer un audio de synthese vocale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text-zu-Sprache-Audio rendern")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trasforma l'audio in testo vocale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Воспроизведение аудио с помощью преобразования текста в речь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Renderizar audio de texto a voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将文本转换为语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト読み上げオーディオをレンダリングする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट-टू-स्पीच ऑडियो प्रस्तुत करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renderizar áudio de texto para fala")
	return /** @type {LocalizedString} */ ("Render text-to-speech audio")
});